


import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import { toast } from 'react-toastify';
import Swal from "sweetalert2";

const Withdraw = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([

    ]);
    const url = process.env.REACT_APP_LINK
    const token = localStorage.getItem("token")
    const [data, setData] = useState({
        email: "",
        password: "",
        full_name: "",
        mobile: ""
    })


    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
    };

    const fetchUsers = async () => {
        try {
            const response = await fetch(`${url}/api/withdraw/admin1997`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            });
            const data = await response.json();
            setEmployees(data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    // Fetch users from backend
    useEffect(() => {


        fetchUsers();
    }, []);

    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        const filtered = employees.filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1);
    }, [searchQuery, employees]);

    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const statusOptions = [
        { value: 'Active', label: 'Active' },
        { value: 'Inactive', label: 'Inactive' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isEdit = data.id !== undefined;
        const urlmain = isEdit
            ? `${url}/api/user/change/${data.id}`
            : `${url}/api/user/signup`;
        const method = isEdit ? 'PUT' : 'POST';

        const payload = {
            email: data.email,
            password: data.password || null,
            full_name: data.full_name || null,
            mobile: data.mobile,
            //    end_date: data.end,
            //    used_by: data.used_by,
            //    status: data.status?.value
        };

        try {
            const res = await fetch(urlmain, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const result = await res.json();
            if (res.ok) {
                const mappedResult = {
                    id: result.id,
                    email: result.email,
                    password: result.password,
                    full_name: result.full_name,
                    mobile: result.mobile,

                };


                toast.success(isEdit ? 'User updated' : 'User added');
                //    fetchCoupon();
                // setCoupons(prev => isEdit
                //     ? prev.map(c => c.id === result.id ? mappedResult : c)
                //     : [...prev, mappedResult]
                // );

                fetchUsers();
                setIsModalOpen(false);
                setData({
                    email: "",
                    password: "",
                    full_name: "",
                    mobile: "",

                });
            } else {
                toast.error(result.message || "Save failed");
            }
        } catch (err) {
            toast.error("Server error");
            console.error(err);
        }
    };
    const handleDelete = async (id) => {
        // Step 1: Show confirmation
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        });

        if (result.isConfirmed) {
            try {
                // Step 2: Delete API call
                const response = await fetch(`${url}/api/event/earning/${id}`, {
                    method: "DELETE",
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });

                const res = await response.json();

                if (response.ok) {
                    // Step 3: Update local state
                    const updatedEmployees = employees.filter(employee => employee.id !== id);
                    setEmployees(updatedEmployees);

                    // Step 4: Show success alert
                    Swal.fire("Deleted!", res.message || "User has been deleted.", "success");
                } else {
                    // Step 5: Show error alert
                    Swal.fire("Error!", res.error || "Something went wrong.", "error");
                }
            } catch (error) {
                console.log(error);
                Swal.fire("Error!", "Something went wrong.", "error");
            }
        }
    };

    const handleSuccess = async (id) => {
        try {
            const response = await fetch(`${url}/api/withdraw/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({
                    status: "Success"
                })
            })
            const res = await response.json();
            if (response.ok) {
               setEmployees(prev =>
                    prev.map(emp =>
                        emp.id === id ? { ...emp, status: "Success" } : emp
                    )
                );

            }
        } catch (error) {
            console.log(error)
        }
    }

    // Mark as Pending
    const handlePending = async (id) => {
        try {
            const response = await fetch(`${url}/api/withdraw/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ status: "Pending" })
            });
            if (response.ok) {
                setEmployees(prev =>
                    prev.map(emp =>
                        emp.id === id ? { ...emp, status: "Pending" } : emp
                    )
                );
            }
        } catch (err) {
            console.log(err);
        }
    };

    // Reject
    const handleReject = async (id) => {
        try {
            const response = await fetch(`${url}/api/withdraw/${id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify({ status: "Rejected" })
            });
            if (response.ok) {
                setEmployees(prev =>
                    prev.map(emp =>
                        emp.id === id ? { ...emp, status: "Rejected" } : emp
                    )
                );
            }
        } catch (err) {
            console.log(err);
        }
    };


    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">All Earning</h1>
                    {/* <button className="oms-add-btn" onClick={() => {
                        setIsModalOpen(true)
                        setData({
                            email: "",
                            password: "",
                            full_name: "",
                            mobile: "",

                        });
                    }}>
                        Add User
                    </button> */}
                </div>
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div>

                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>ID</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((employee, index) => (
                                    <tr key={index}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}.</td>
                                        <td>{employee.username}</td>

                                        <td>{employee.user_id}</td>
                                        <td>{(employee.withdraw_amount)}</td>

                                        <td>{employee.status}</td>

                                        <td>
                                                {/* Pending status actions */}
                                                {employee.status === "Pending" && (
                                                    <>
                                                        {/* Mark as Success */}
                                                        <button
                                                            onClick={() => handleSuccess(employee.id)}
                                                            style={{
                                                                background: "transparent",
                                                                border: "none",
                                                                color: "green",
                                                                fontSize: "16px",
                                                                cursor: "pointer",
                                                                transition: "0.2s",
                                                                marginRight: "5px"
                                                            }}
                                                            title="Mark as Success"
                                                        >
                                                            <i className="fa-solid fa-check success-oms"></i>
                                                        </button>

                                                        {/* Reject */}
                                                        <button
                                                            onClick={() => handleReject(employee.id)}
                                                            style={{
                                                                background: "transparent",
                                                                border: "none",
                                                                color: "red",
                                                                fontSize: "16px",
                                                                cursor: "pointer",
                                                                transition: "0.2s"
                                                            }}
                                                            title="Reject"
                                                        >
                                                            <i className="fa-solid fa-xmark"></i>
                                                        </button>
                                                    </>
                                                )}

                                                {/* Success status actions */}
                                                {employee.status === "Success" && (
                                                    <>
                                                        {/* Revert to Pending */}
                                                        <button
                                                            onClick={() => handlePending(employee.id)}
                                                            style={{
                                                                background: "transparent",
                                                                border: "none",
                                                                color: "orange",
                                                                fontSize: "16px",
                                                                cursor: "pointer",
                                                                transition: "0.2s",
                                                                marginRight: "5px"
                                                            }}
                                                            title="Mark as Pending"
                                                        >
                                                            <i className="fa-solid fa-clock"></i>
                                                        </button>

                                                        {/* Keep Reject */}
                                                        <button
                                                            onClick={() => handleReject(employee.id)}
                                                            style={{
                                                                background: "transparent",
                                                                border: "none",
                                                                color: "red",
                                                                fontSize: "16px",
                                                                cursor: "pointer",
                                                                transition: "0.2s"
                                                            }}
                                                            title="Reject"
                                                        >
                                                            <i className="fa-solid fa-xmark"></i>
                                                        </button>
                                                    </>
                                                )}

                                                {/* Rejected status actions */}
                                                {employee.status === "Rejected" && (
                                                    <>
                                                        {/* Revert to Pending */}
                                                        <button
                                                            onClick={() => handlePending(employee.id)}
                                                            style={{
                                                                background: "transparent",
                                                                border: "none",
                                                                color: "orange",
                                                                fontSize: "16px",
                                                                cursor: "pointer",
                                                                transition: "0.2s"
                                                            }}
                                                            title="Mark as Pending"
                                                        >
                                                            <i className="fa-solid fa-clock"></i>
                                                        </button>
                                                    </>
                                                )}

                                               
                                          


                                            
                                        </td>
                                        {/* <td>
                                            <button onClick={() => handleDelete(employee.email)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="12" style={{ textAlign: 'center' }}>No users found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                    </button>



                    <button className="active">
                        {currentPage}
                    </button>

                    {currentPage < totalPages && (
                        <button onClick={() => paginate(currentPage + 1)}>
                            {currentPage + 1}
                        </button>
                    )}

                    {currentPage + 1 < totalPages && (
                        <span className="dots">...</span>
                    )}

                    {currentPage !== totalPages && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>

        </>
    );
};

export default Withdraw;
